export const formatClock = (hour, minute) => {
  const suffix = hour < 12 ? "AM" : "PM";
  const twelveHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${twelveHour}:${String(minute).padStart(2, "0")} ${suffix}`;
};

export const formatVenueDate = (iso, { month = "short" } = {}) => {
  const [date] = String(iso).split("T");
  const [year, monthNumber, day] = date.split("-").map(Number);
  if (!year || !monthNumber || !day) return iso;

  return new Date(year, monthNumber - 1, day).toLocaleDateString("en-US", {
    month,
    day: "numeric",
    year: "numeric",
  });
};

export const formatVenueDateTime = (iso, { month = "short" } = {}) => {
  const [date, clock = ""] = String(iso).split("T");
  const [year, monthNumber, day] = date.split("-").map(Number);
  if (!year || !monthNumber || !day) return iso;

  const [hour, minute] = clock.split(":").map(Number);
  if (!hour && !minute) return formatVenueDate(iso, { month });

  return `${formatVenueDate(iso, { month })} at ${formatClock(hour || 0, minute || 0)}`;
};
